const VALID_BLACK_KEYS = ['s', 'd', 'g', 'h', 'j', 'l', ';', '2', '3', '4', '6', '7', '9', '0', '-'];

const VALID_WHITE_KEYS = ['z', 'x', 'c', 'v', 'b', 'n', 'm', ',', '.', '/', 'q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', '['];

const VALID_KEYS = [...VALID_BLACK_KEYS, ...VALID_WHITE_KEYS];

const NOTES = [
  'C3', 'Db3', 'D3', 'Eb3',
  'E3', 'F3', 'Gb3', 'G3',
  'Ab3', 'A3', 'Bb3', 'B3',
  'C4', 'Db4', 'D4', 'Eb4',
  'E4', 'F4', 'Gb4', 'G4',
  'Ab4', 'A4', 'Bb4', 'B4',
  'C5', 'Db5', 'D5', 'Eb5',
  'E5', 'F5', 'Gb5', 'G5',
  'Ab5', 'A5', 'Bb5', 'B5'
];

const NOTE_TO_KEY = {
  'C3': 'z',
  'Db3': 's',
  'D3': 'x',
  'Eb3': 'd',
  'E3': 'c',
  'F3': 'v',
  'Gb3': 'g',
  'G3': 'b',
  'Ab3': 'h',
  'A3': 'n',
  'Bb3': 'j',
  'B3': 'm',
  'C4': ',',
  'Db4': 'l',
  'D4': '.',
  'Eb4': ';',
  'E4': '/',
  'F4': 'q',
  'Gb4': '2',
  'G4': 'w',
  'Ab4': '3',
  'A4': 'e',
  'Bb4': '4',
  'B4': 'r',
  'C5': 't',
  'Db5': '6',
  'D5': 'y',
  'Eb5': '7',
  'E5': 'u',
  'F5': 'i',
  'Gb5': '9',
  'G5': 'o',
  'Ab5': '0',
  'A5': 'p',
  'Bb5': '-',
  'B5': '[',
};

const KEY_TO_NOTE = {
  'z': 'C3',
  's': 'Db3',
  'x': 'D3',
  'd': 'Eb3',
  'c': 'E3',
  'v': 'F3',
  'g': 'Gb3',
  'b': 'G3',
  'h': 'Ab3',
  'n': 'A3',
  'j': 'Bb3',
  'm': 'B3',
  ',': 'C4',
  'l': 'Db4',
  '.': 'D4',
  ';': 'Eb4',
  '/': 'E4',
  'q': 'F4',
  '2': 'Gb4',
  'w': 'G4',
  '3': 'Ab4',
  'e': 'A4',
  '4': 'Bb4',
  'r': 'B4',
  't': 'C5',
  '6': 'Db5',
  'y': 'D5',
  '7': 'Eb5',
  'u': 'E5',
  'i': 'F5',
  '9': 'Gb5',
  'o': 'G5',
  '0': 'Ab5',
  'p': 'A5',
  '-': 'Bb5',
  '[': 'B5'
};

export {
  NOTES,
  VALID_KEYS,
  NOTE_TO_KEY,
  KEY_TO_NOTE,
};
